import React, { useEffect, useRef } from 'react';

const AdUnit = ({
  client = 'ca-pub-2811591266080010', 
  slot,
  format = 'auto',
  style = { display: 'block' },
  className = '',
}) => {
  const adRef = useRef(null);

  useEffect(() => {
    // Only proceed if adsbygoogle is available and we have a reference
    if (window.adsbygoogle && adRef.current) {
      
      // Check if the ad has already been initialized
      const isLoaded = adRef.current.getAttribute('data-adsbygoogle-status');
      
      if (!isLoaded) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (error) {
          // If it's just a "TagError", we can ignore it as it usually 
          // means Google tried to double-process a unit.
          if (error.name !== 'TagError') {
            console.error("AdSense push error:", error);
          }
        }
      }
    }
  }, [slot]); // Depend on slot so it refreshes when navigation changes

  return (
    <div 
      className={`ad-container ${className}`} 
      style={{ overflow: 'hidden', ...style }}
      key={slot} // KEY is critical: it forces React to recreate the element if the slot changes
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdUnit;